"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_inputrules_1 = require("prosemirror-inputrules");

var Node_1 = __importDefault(require("./Node"));

var HorizontalRule =
/*#__PURE__*/
function (_Node_1$default) {
  _inherits(HorizontalRule, _Node_1$default);

  function HorizontalRule() {
    _classCallCheck(this, HorizontalRule);

    return _possibleConstructorReturn(this, _getPrototypeOf(HorizontalRule).apply(this, arguments));
  }

  _createClass(HorizontalRule, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return function (attrs) {
        return function (state, dispatch) {
          dispatch(state.tr.replaceSelectionWith(type.create(attrs)).scrollIntoView());
          return true;
        };
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      return {
        "Mod-_": function Mod_(state, dispatch) {
          dispatch(state.tr.replaceSelectionWith(type.create()).scrollIntoView());
          return true;
        }
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [new prosemirror_inputrules_1.InputRule(/^(?:---|___\s|\*\*\*\s)$/, function (state, match, start, end) {
        var tr = state.tr;

        if (match[0]) {
          var markup = match[0].trim();
          tr.replaceWith(start - 1, end, type.create({
            markup: markup
          }));
        }

        return tr;
      })];
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.write("\n".concat(node.attrs.markup));
      state.closeBlock(node);
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        node: "hr",
        getAttrs: function getAttrs(tok) {
          return {
            markup: tok.markup
          };
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "hr";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: {
          markup: {
            default: "---"
          }
        },
        group: "block",
        parseDOM: [{
          tag: "hr"
        }],
        toDOM: function toDOM(node) {
          return ["hr", {
            class: node.attrs.markup === "***" ? "page-break" : ""
          }];
        }
      };
    }
  }]);

  return HorizontalRule;
}(Node_1.default);

exports.default = HorizontalRule;